import { isNull } from 'utils/validation';

export default (url) => {
  if (isNull(url)) return '';
  const splitted = url.split('/');
  return splitted[splitted.length - 1];
};
